import { render, staticRenderFns } from "./StudyQuizQuestionHemoglobin.vue?vue&type=template&id=d0054ade"
import script from "./StudyQuizQuestionHemoglobin.vue?vue&type=script&lang=js"
export * from "./StudyQuizQuestionHemoglobin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports